import { BillingIcon } from "outline-icons";
import stores from "~/stores";
import { createLazyComponent } from "~/components/LazyLoad";
import { Hook, PluginManager } from "~/utils/PluginManager";
import config from "../plugin.json";

PluginManager.add([
  {
    ...config,
    type: Hook.Settings,
    value: {
      group: "Workspace",
      after: "Details",
      icon: BillingIcon,
      component: createLazyComponent(() => import("./Billing")),
      enabled: (team) => {
        const can = stores.policies.abilities(team.id);
        return (
          (team.trialEndsAt && can.createPlanSubscription) ||
          can.updatePlanSubscription
        );
      },
    },
  },
]);
